'use client'

import DriverOnWay from '@/assets/imgs/driver-on-way.svg'
import DriverWaiting from '@/assets/imgs/driver-waiting.svg'
import OnGoing from '@/assets/imgs/on_going.svg'
import { cn } from '@/core/lib/utils/cn'
import { useAuth } from '@/core/store/auth'
import { TripDetailsModel } from '@/features/trips/types/models/trip-details.model'
import { TripStatus } from '@/features/trips/types/models/trip-statuses.enum'
import { useTranslations } from 'next-intl'
import { use, useState } from 'react'

type Props = {
  currentTripPromise: Promise<TripDetailsModel | null>
}

export const CurrentTrip: React.FC<Props> = ({ currentTripPromise }) => {
  const t = useTranslations()
  const [isActive, setIsActive] = useState(true)
  const { isAuthenticated } = useAuth()
  if (!isAuthenticated) {
    return null
  }
  let tripStatus: { text: string; image: string } | null = null
  const currentTrip = use(currentTripPromise)
  if (currentTrip?.status?.id === TripStatus.DRIVER_ON_THE_WAY) {
    tripStatus = {
      text: currentTrip?.status.name,
      image: DriverOnWay,
    }
  }
  if (currentTrip?.status?.id === TripStatus.ON_SPOT) {
    tripStatus = {
      text: currentTrip?.status.name,
      image: DriverWaiting,
    }
  }
  if (currentTrip?.status?.id === TripStatus.DRIVER_ASSIGNED) {
    tripStatus = {
      text: currentTrip?.status.name,
      image: DriverWaiting,
    }
  }
  if (currentTrip?.status?.id === TripStatus.DONE) {
    tripStatus = {
      text: currentTrip?.status.name,
      image: DriverWaiting,
    }
  }
  if (currentTrip?.status?.id === TripStatus.ON_GOING) {
    tripStatus = {
      text: currentTrip?.status.name,
      image: OnGoing,
    }
  }
  if (!currentTrip || !tripStatus) {
    return null
  }

  const TripStatusImage = tripStatus.image

  return (
    <button
      className={cn(
        'border-grey-20 fixed top-1/4 right-0 z-50 cursor-pointer rounded border bg-white px-8 py-2 transition-transform',
        isActive && 'translate-x-5',
        !isActive &&
          'translate-x-[calc(100%_-_30px)] min-[28rem]:translate-x-[calc(100%_-_40px)]',
      )}
      onClick={() => setIsActive(active => !active)}
      tabIndex={0}
    >
      <div className='bg-pale-blue absolute top-0 left-0 h-full text-center font-bold [writing-mode:vertical-lr]'>
        {t('currentTrip.title')}
      </div>
      <div className='flex gap-5'>
        <div className='flex w-52 flex-col'>
          <h2 className='text-sm font-medium'>
            {t('trip.trip')} #{currentTrip?.id}
          </h2>
          <h4 className='text-lg font-medium capitalize'>{tripStatus?.text}</h4>
          <p className='text-grey-50 font-medium'>
            {t('currentTrip.description')}
          </p>
        </div>
        <TripStatusImage />
      </div>
    </button>
  )
}
